import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import MultiselectFilter from '../MultiselectFilter/MultiselectFilter';
import PatternList from '../PatternList/PatternList';
import { visualizerActions,uiActions } from "../../store";
import styles from './PatternsPage.module.css';
import TopMenu from '../TopMenu/TopMenu';
import PatternSizeSelectorModal from '../PatternSizeSelectorModal/PatternSizeSelectorModal';

export default function PatternsPage() {
    const navigate = useNavigate();
    const patternData = useSelector((state) => state.visualizer.patternData);
    const dispatch = useDispatch();
    const appliedFilters = useSelector((state) => state.visualizer.appliedFilters);
    const patternSizeSelectorModalStatus = useSelector((state) => state.ui.PatternSizeSelectorModalActive);
    const activePattern = useSelector((state) => state.visualizer.activePattern);
    const getAppliedFilterValue = (name) => {
        const filters = appliedFilters.filter(f => f.groupId === 'patternFilters' && f.name === name);
        return filters.length ? filters.map(f => f.value) : []; 
    };
    

    const handleCheckboxChange = (e, value) => {
        const { checked } = e.target;
        const name = e.target.name;
    
        if (value === 'all') {
            // cler all other filters for this category and check "all"
            dispatch(visualizerActions.clearAppliedFilterByName({ name }));
    
            // uncheck all other checkboxes in the same group
            const checkboxes = document.querySelectorAll(`input[name="${name}"]`);
            checkboxes.forEach((checkbox) => {
                if (checkbox.value !== 'all') {
                    checkbox.checked = false;
                }
            });
        } else {
            if (checked) {
                // uncheck the "all" option if any specific value is selected
                const allCheckbox = document.querySelector(`input[name="${name}"][value="all"]`);
                if (allCheckbox) {
                    allCheckbox.checked = false;
                }
    
                // add the filter
                dispatch(visualizerActions.removeAppliedFilter({ name, value: 'all' }));
                if (!appliedFilters.some(filter => filter.name === name && filter.value === value)) {
                    dispatch(visualizerActions.addAppliedFilter({ groupId: "patternFilters", name, value, label: value }));
                    dispatch(visualizerActions.setLastAppliedFilter("patternFilters"));
                }
            } else {
                // remove the filter
                if (appliedFilters.some(filter => filter.name === name && filter.value === value)) {
                    dispatch(visualizerActions.removeAppliedFilter({ name, value }));
                }
            }
        }
    };

    const handlePatternSizeSelect = (selectedPattern) => {
                console.log('selectedPattern', selectedPattern)
                if(selectedPattern.type=='Pattern Inspirations'){
                    if(window.location.href.indexOf("staging") !== -1){
                        window.location.href = selectedPattern.link;
                    }
                    else{
                        window.location.href = selectedPattern.link.replace("staging","");
                    }
                    
                    return;
                }else{
                    dispatch(visualizerActions.clearTileSelections());
                    
                    // Navigate to new URL format with pattern ID and default products (-1)
                    const patternId = selectedPattern.id || selectedPattern.description;
                    navigate(`/visualizer/pattern/${patternId}/products/-1`);
                }
        
                dispatch(uiActions.setPatternSizeSelectorModalActive(false));
            };
        
    
    

    return (
        <>
            {/* <TopMenu /> */}
            <section>
 
                <div className={styles.content}>
                <div className={styles.landingHeader}>               
                <h1>Amtico Laying Patterns</h1>
                <h4>Create your pattern</h4>
                  </div> 
                    <div className={styles.patternsContainer}>
                        <PatternList />
                    </div>
                </div>
              
            </section>

            {patternSizeSelectorModalStatus && <PatternSizeSelectorModal handlePatternSizeSelect={handlePatternSizeSelect} />}
        </>
    );
}
